import rAF from './rAF';
import gt from 'lodash/gt';
import inRange from 'lodash/inRange';

const ANIMATION_DURATION = 250;

const HEADER_TOP = 64;

export default function scrollIntoViewIfNeeded(el, useAnimation = false, duration = ANIMATION_DURATION,
                                               atCenter = false) {

   const parent = _getScrollableParent(el);
   if (!parent) {
      return;
   }

   const { top, bottom } = el.getBoundingClientRect();
   const rect = parent.getBoundingClientRect();

   let visible = true;
   // eslint-disable-next-line no-magic-numbers
   visible = visible && gt(top, 0);
   visible = visible && inRange(top, rect.top, rect.bottom);
   visible = visible && inRange(bottom, rect.top, rect.bottom);

   if (visible) {
      return;
   }

   const startPosition = parent.scrollTop;
   const delta = Math.floor(top - rect.top);
   let destination = parent === _mainScrollingElement() ? delta - HEADER_TOP : startPosition + delta;

   if (atCenter) {
      destination -= (rect.bottom - rect.top) / 2;
   }

   if (useAnimation) {
      _animateMe(function _scrollStep(easing) {
         _scrollTo(parent, startPosition + (destination - startPosition) * easing);
      }, duration);
   } else {
      _scrollTo(parent, destination);
   }
}

function _getScrollableParent(node) {
   const body = document.body;
   node = node.parentElement;
   while (node) {
      if (_hasScroll(node)) {
         return node === body || node.contains(body) ? _mainScrollingElement() : node;
      }

      if (!node.parentElement) {
         return null;
      }
      node = node.parentElement;
   }

   return null;
}

function _mainScrollingElement() {
   // eslint-disable-next-line no-extra-parens
   return document.scrollingElement || document.documentElement;
}

function _scrollTo(el, top) {
   el.scrollTop = top;
}

function _animateMe(callback, duration = ANIMATION_DURATION, easingFn = _quadratic) {
   const startTime = _now();
   const destTime = startTime + duration;

   function _step() {
      const now = _now();

      if ( now >= destTime ) {
         const lastStep = 1;
         callback(lastStep);
         return;
      }

      const easing = easingFn(( now - startTime ) / duration);
      callback(easing);
      rAF(_step);
   }

   _step();
}

function _hasScroll(el) {
   if (el.scrollHeight > (el.clientHeight || el.offsetHeight)) {
      const st = el.scrollTop;
      el.scrollTop = 1;
      if (el.scrollTop) {
         el.scrollTop = st;
         return true;
      }
   }
   return false;
}

function _now() {
   return performance && performance.now ? performance.now() : Date.now();
}

function _quadratic(k) {
   // eslint-disable-next-line no-magic-numbers
   return k * ( 2 - k );
}
